import axiosInstance from '@/shared/api/axios';
import type {
  ApiUserPackageDetailGetResponse,
  ApiUserPackagesGetResponse,
} from '@/shared/types/api/packages';

// GET /packages/my — paginated list of packages that contain at least one
// of the caller's parcels. Backend deduplicates by package id.
export const apiUserPackagesGet = async (
  page: number = 1,
  pageSize: number = 10,
): Promise<ApiUserPackagesGetResponse> => {
  const { data } = await axiosInstance.get<ApiUserPackagesGetResponse>(
    '/packages/my',
    { params: { page, page_size: pageSize } },
  );
  return data;
};

// GET /packages/my/<id> — package info + the caller's parcels in it.
export const apiUserPackageDetailGet = async (
  id: string,
): Promise<ApiUserPackageDetailGetResponse> => {
  const { data } = await axiosInstance.get<ApiUserPackageDetailGetResponse>(
    `/packages/my/${id}`,
  );
  return data;
};
